import React from 'react';
import { QuestionComponentProps, QuestionData } from '../../type';
import FillInTheBlank_Results from '../FillInTheBlank/FillInTheBlank_Results';
import MultipleChoice_Results from '../MultipleChoice/MultipleChoice_Results';
import Unscramble_Results from '../Unscramble/Unscramble_Results';
import TickTF_Results from '../TickTF/TickTF_Results';

const Combine_Results = ({ questionIndex, questionData, isCombineChild }: QuestionComponentProps) => {
  const { answers, audioUrl } = questionData;
  const QuestionAnswers = ({ question, index }: { question: QuestionData; index: number }) => {
    const componentType = (question.type ?? '').toUpperCase();
    const data: QuestionComponentProps = {
      questionIndex: index,
      questionData: question,
      isCombineChild: true,
    };
    switch (componentType) {
      case 'FILLINTHEBLANK':
        return <FillInTheBlank_Results {...data} />;
      case 'MULTIPLECHOICE':
        return <MultipleChoice_Results {...data} />;
      case 'UNSCRAMBLE':
        return <Unscramble_Results {...data} />;
      case 'TICKTF':
        return <TickTF_Results {...data} />;
      default:
        return <></>;
    }
  };

  return (
    <div style={{ display: 'flex', gap: 5 }}>
      <div>
        <span>{questionIndex + 1}.</span>
      </div>
      <div>
        {answers.map((question, index) => (
          <QuestionAnswers index={index} question={question} />
        ))}
      </div>
    </div>
  );
};

export default Combine_Results;
